const DATA = {
  primary: "primary",
  secondary: "secondary",
  tertiary: "tertiary",
  quaternary: "quaternary",
  //
  blue: "primary",
  green: "secondary",
  light_blue: "tertiary",
  "light blue": "tertiary",
  orange: "quaternary",
  //
  light: "light",
  dark: "dark",
  white: "white",
  black: "black",
};

export const convertColorName = (name) => {
  if (name in DATA) {
    return DATA[name];
  }

  return name;
};
